import React, { FC, useMemo, useState } from 'react'
import { Input, Modal, ModalProps, Typography } from 'antd'
import { useLocalization } from 'localization'
import { useHideModal } from 'components/Modals'
import Container from 'components/Container'

export interface IConfirmModal extends Pick<ModalProps, 'title' | 'okText' | 'confirmLoading' | 'okType'> {
	submit: () => Promise<void>
	subtitle: string | JSX.Element
	hardConfirmWord?: string
}

const ConfirmModal: FC<IConfirmModal> = ({
	title,
	subtitle,
	okText,
	submit,
	confirmLoading,
	hardConfirmWord,
	okType = 'danger',
}) => {
	const { t } = useLocalization()
	const hideModal = useHideModal()
	const [confirmValue, setConfirmValue] = useState('')

	const onClose = () => {
		hideModal()
	}

	const onSubmit = async () => {
		await submit()
		onClose()
	}

	const confirmationKey = useMemo(() => hardConfirmWord?.toUpperCase(), [hardConfirmWord])

	return (
		<Modal
			title={title}
			width={660}
			open
			okButtonProps={{
				type: 'primary',
				disabled: !!hardConfirmWord && confirmValue !== confirmationKey,
			}}
			okType={okType}
			okText={okText || t('actions.confirm')}
			onOk={onSubmit}
			confirmLoading={confirmLoading}
			cancelText={t('actions.cancel')}
			onCancel={onClose}
		>
			<Container display="flex" flexDirection="column" space="lg" spaceDirection="vertical">
				<Typography.Text>{subtitle}</Typography.Text>
				{hardConfirmWord && (
					<Container display="flex" flexDirection="column" space="xs" spaceDirection="vertical">
						<Typography.Text>{t('transactions.removeAll.confirmation', { confirmationKey })}</Typography.Text>
						<Input value={confirmValue} placeholder={confirmationKey} onChange={e => setConfirmValue(e.target.value)} />
					</Container>
				)}
			</Container>
		</Modal>
	)
}

export default ConfirmModal
